<template>
  <div>
    <v-tooltip bottom v-if="value">
      <template v-slot:activator="{ on, attrs }">
        <v-icon small v-bind="attrs" v-on="on" color="green darken-4">mdi-sync</v-icon>
      </template>
      <span>{{ $t('saved') }}</span>
    </v-tooltip>
    <v-tooltip bottom v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-icon small v-bind="attrs" v-on="on" color="red darken-4">mdi-sync-alert</v-icon>
      </template>
      <span>{{ $t('not_saved') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CommonIsSaved",
  inheritAttrs: false,
  props: {
    value: {default: true},
  },

  computed: {},

  methods: {},

  mounted() {
  },
  beforeDestroy() {
  },
  data() {
    return {}
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>